<div class="step-container registration-questions">
  <div class="d-flex flex-column justify-content-between h-100">
    <div *ngIf="registrationUserQuestions$ | async as registrationUserQuestions; else loading">
      <h5 class="registration-questions-title">
        {{
          'fgbcl.registration.questions.title'
            | translate: { firstName: registrationUserQuestions.FirstName, lastName: registrationUserQuestions.LastName }
        }}
      </h5>
      <p
        class="registration-questions-instructions"
        [innerHtml]="'fgbcl.registration.questions.instructions' | translate | markdownTranslate"
      ></p>

      <div class="questions-container row">
        <div class="question-wrapper col-lg-6" *ngFor="let questionAndAnswer of registrationUserQuestions.ClubQuestionAnswer">
          <div [ngSwitch]="questionAndAnswer.Question.QuestionType" class="question-type">
            <!-- Dropdown -->
            <div class="question-dropdown" *ngSwitchCase="questionType.DropDown">
              <div class="form-floating">
                <select
                  class="form-select"
                  (change)="handleAnswerChange()"
                  [(ngModel)]="answers[questionAndAnswer.Question.Id]"
                  required
                >
                  <option value="0" selected hidden>
                    {{ 'fgbcl.registration.questions.question.' + questionAndAnswer.Question.Id + '.placeholder' | translate }}
                  </option>
                  <option *ngFor="let answer of questionAndAnswer.Answer" [value]="answer.Id">
                    {{ answer.Answer }}
                  </option>
                </select>
                <label class="text-white fw-normal">{{ questionAndAnswer.Question.Question }}</label>
              </div>
            </div>

            <!-- Multiselect -->
            <div class="question-multi-select" *ngSwitchCase="questionType.MultiSelect">
              <div *ngFor="let answer of questionAndAnswer.Answer" class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="answers[questionAndAnswer.Question.Id + '__' + answer.Id]"
                  [attr.name]="answer.QuestionId"
                  [value]="answer.Id"
                  [id]="answer.QuestionId + '__' + answer.Id"
                  required
                  (click)="handleAnswerChange()"
                />
                <label class="form-check-label" [for]="answer.QuestionId + '__' + answer.Id">
                  {{ answer.Answer }}
                </label>
              </div>
            </div>

            <!-- Radio -->
            <div class="question-radio" *ngSwitchCase="questionType.Radio">
              <div *ngFor="let answer of questionAndAnswer.Answer" class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  [(ngModel)]="answers[questionAndAnswer.Question.Id]"
                  [attr.name]="answer.QuestionId"
                  [value]="answer.Id"
                  [id]="answer.QuestionId + '__' + answer.Id"
                  required
                  (click)="handleAnswerChange()"
                />
                <label class="form-check-label" [for]="answer.QuestionId + '__' + answer.Id">
                  {{ answer.Answer }}
                </label>
              </div>
            </div>

            <!-- Textbox -->
            <div *ngSwitchDefault>
              <div class="form-floating">
                <input
                  type="text"
                  (ngModelChange)="handleAnswerChange()"
                  class="form-control"
                  [(ngModel)]="answers[questionAndAnswer.Question.Id]"
                  required
                />
                <label class="text-white fw-normal">{{ questionAndAnswer.Question.Question }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Server Side Errors -->
      <fgbcl-errors></fgbcl-errors>
    </div>
    <fgbcl-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgbcl-registration-navigation>
  </div>
</div>
